import ErrorModal from 'components/Modals/ErrorModal/ErrorModal';
import SocialSharingModal from 'components/Modals/SocialSharingModal/SocialSharingModal';
import SiteFooter from 'components/SiteFooter/SiteFooter';
import SiteHeader from 'components/SiteHeader/SiteHeader';
import Sourcepoint from 'config/Sourcepoint';
import { useIsFeaturedPage } from 'hooks/useIsFeaturedPage';
import { observer } from 'mobx-react-lite';
import AuthProvider from 'providers/AuthProvider';
import { SocialShareModalProvider } from 'providers/SocialShareModalProvider';
import React from 'react';
import { Outlet, useLocation } from 'react-router-dom';

const backgroundColors: Record<string, string> = Object.freeze({
  '/partnerships': '#fff',
  '/return-label': '#E9FEB2',
});

const Main = observer(() => {
  useIsFeaturedPage();
  const location = useLocation();
  const backgroundColor = backgroundColors[location.pathname] ?? 'transparent';

  return (
    <AuthProvider>
      <SocialShareModalProvider>
        <SiteHeader />
        <main
          id="main"
          className="flex-grow-1 d-flex flex-column"
          style={{ backgroundColor }}
        >
          <Outlet />
        </main>
        <SiteFooter />
        <Sourcepoint />
        <SocialSharingModal />
        <ErrorModal />
      </SocialShareModalProvider>
    </AuthProvider>
  );
});

export default Main;
